import { useState } from "react";
import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { submitAdminVisitForm } from "../../../Redux/actions/responseAction";
import { toastMessage } from "../../../utils/toast";
import { ModalBaseStyles, ModalHeader } from "../../Common/styles/modal";

const VisitSubmitButton = () => {
  const { t } = useTranslation("responses");
  const dispatch = useAppDispatch();
  const { id: studyId, participantId } = useParams();
  const [showConfirm, setShowConfirm] = useState(false);

  const currentCategory = useAppSelector(
    (state) => state.response.currentCategory,
  );
  const selectedForm = useAppSelector((state) => state.response.selectedForm);
  const canLock = useAppSelector((state) => state.response.canLock);
  const isResponseSubmitting = useAppSelector(
    (state) => state.response.fieldSubmitting,
  );
  const isResponseLoading = useAppSelector((state) => state.response.isLoading);

  // Gated on canLock (participant.lock_unlock), not the general edit
  // permission — Submit is a lock action, same as the form's Lock/Unlock
  // menu, so it's available to the same set of users regardless of whether
  // they can also edit answers.
  const showButton =
    currentCategory === "visit" &&
    !!selectedForm &&
    !selectedForm.locked &&
    !selectedForm.isSigned &&
    canLock;

  if (!showButton) {
    return null;
  }

  const openConfirm = () => {
    if (isResponseSubmitting || isResponseLoading) return;
    if (!selectedForm?.readyToSubmit) {
      toastMessage("warning", t("SURVEY_SUBMIT_INCOMPLETE"));
      return;
    }
    setShowConfirm(true);
  };

  const confirmSubmit = () => {
    setShowConfirm(false);
    if (studyId && participantId) {
      dispatch(submitAdminVisitForm(studyId, participantId));
    }
  };

  return (
    <>
      <Button
        variant="contained"
        onClick={openConfirm}
        disabled={!!isResponseSubmitting}
      >
        {t("VISIT_SUBMIT_BUTTON")}
      </Button>
      <Modal open={showConfirm} onClose={() => setShowConfirm(false)}>
        <Box
          sx={{ ...ModalBaseStyles, height: "fit-content", minHeight: "20vh" }}
        >
          <ModalHeader
            title={t("VISIT_SUBMIT_CONFIRM_TITLE")}
            onCloseClick={() => setShowConfirm(false)}
          />
          <Typography variant="subtitle1">
            {t("VISIT_SUBMIT_CONFIRM_BODY")}
          </Typography>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            sx={{ marginTop: "auto" }}
            gap={1.5}
          >
            <Button variant="outlined" onClick={() => setShowConfirm(false)}>
              {t("CANCEL", { ns: "common" })}
            </Button>
            <Button
              variant="contained"
              onClick={confirmSubmit}
              disabled={!!isResponseSubmitting}
            >
              {t("VISIT_SUBMIT_BUTTON")}
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default VisitSubmitButton;
